module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pcOrder"
  }, [_c('p', {
    staticClass: "clearfix",
    staticStyle: {
      "margin-top": "10px",
      "color": "red"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "select-wrap",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "goods-cont"
  }, [_c('div', {
    staticClass: "goods-left"
  }, [_c('div', {
    staticClass: "filter"
  }, [_c('el-form', {
    staticClass: "demo-form-inline",
    attrs: {
      "inline": true,
      "model": _vm.formInline
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择分类"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "活动区域"
    },
    model: {
      value: (_vm.typeId),
      callback: function($$v) {
        _vm.typeId = $$v
      },
      expression: "typeId"
    }
  }, [_c('el-option', {
    key: "",
    attrs: {
      "label": "全部",
      "value": ""
    }
  }), _vm._v(" "), _vm._l((_vm.systemData), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), _vm._v(" "), _vm._l((_vm.typeList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  })], 2)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "warning"
    },
    on: {
      "click": _vm.getGoods
    }
  }, [_vm._v("查询")])], 1)], 1), _vm._v(" "), _c('div', {
    staticStyle: {
      "display": "flex",
      "align-items": "flex-start"
    }
  }, [_c('el-button', {
    staticClass: "upLoad",
    attrs: {
      "type": "danger",
      "size": ""
    },
    on: {
      "click": _vm.coverImg
    }
  }, [_c('input', {
    staticClass: "pcImgFile",
    attrs: {
      "type": "file",
      "accept": ".png,.jpg,.jpeg",
      "title": "选择图片"
    },
    on: {
      "change": _vm.coverImg
    }
  }), _vm._v("上传背景")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.openBigScreen
    }
  }, [_vm._v("查看大屏")]), _vm._v(" "), _c('el-button', {
    staticStyle: {
      "margin-left": "20px"
    },
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.clearBg
    }
  }, [_vm._v("恢复默认样式")]), _vm._v(" "), _c('span', {
    staticClass: "txt-color",
    staticStyle: {
      "height": "37px"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.isBold),
      callback: function($$v) {
        _vm.isBold = $$v
      },
      expression: "isBold"
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "-1"
    }
  }, [_vm._v("默认字体")]), _vm._v(" "), _c('el-radio', {
    attrs: {
      "label": "1"
    }
  }, [_vm._v("加粗字体")])], 1)], 1), _vm._v(" "), _c('span', {
    staticClass: "txt-color"
  }, [_vm._v("选择字体颜色:"), _c('el-color-picker', {
    model: {
      value: (_vm.textColor),
      callback: function($$v) {
        _vm.textColor = $$v
      },
      expression: "textColor"
    }
  })], 1), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.save
    }
  }, [_vm._v("保存")])], 1)], 1), _vm._v(" "), _c('el-table', {
    ref: "multipleTable",
    attrs: {
      "data": _vm.tableData,
      "row-key": _vm.getRowKeys,
      "tooltip-effect": "dark"
    },
    on: {
      "selection-change": _vm.handleSelectionChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "商品名"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_vm._v(_vm._s(scope.row.productName))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "typeName",
      "label": "分类"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参与排单"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.schedulingEnabled),
            callback: function($$v) {
              _vm.$set(scope.row, "schedulingEnabled", $$v)
            },
            expression: "scope.row.schedulingEnabled"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "参与制作"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-checkbox', {
          model: {
            value: (scope.row.makeEnable),
            callback: function($$v) {
              _vm.$set(scope.row, "makeEnable", $$v)
            },
            expression: "scope.row.makeEnable"
          }
        })]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "price",
      "label": "价格",
      "show-overflow-tooltip": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "width": "450",
      "label": "商品宣传语"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          staticClass: "form-item",
          staticStyle: {
            "display": "flex"
          }
        }, [_c('el-input', {
          attrs: {
            "type": "text",
            "placeholder": "请输入第一句描述",
            "maxlength": 12,
            "size": "small",
            "show-word-limit": ""
          },
          model: {
            value: (scope.row.tips[0]),
            callback: function($$v) {
              _vm.$set(scope.row.tips, 0, $$v)
            },
            expression: "scope.row.tips[0]"
          }
        }), _vm._v(" "), _c('el-input', {
          staticStyle: {
            "margin": "0 10px"
          },
          attrs: {
            "type": "text",
            "placeholder": "请输入第二句描述",
            "maxlength": 12,
            "size": "small",
            "show-word-limit": ""
          },
          model: {
            value: (scope.row.tips[1]),
            callback: function($$v) {
              _vm.$set(scope.row.tips, 1, $$v)
            },
            expression: "scope.row.tips[1]"
          }
        }), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "warning",
            "size": "small"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              return _vm.saveTips(scope.row)
            }
          }
        }, [_vm._v("保存")])], 1)]
      }
    }])
  })], 1)], 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.2.2@vue-loader/lib/template-compiler?{"id":"data-v-0c0d54a0","hasScoped":true}!./~/_vue-loader@12.2.2@vue-loader/lib/selector.js?type=template&index=0!./src/components/indexRouters/goods/bigScreenGoods.vue
// module id = 918
// module chunks = 1